import React from "react";
import openAI from "../../assets/openai.svg";
import { Shimmer } from "@fluentui/react";
import { IPartnerInfoProps } from "../../interfaces/PartnerView.interfaces";

export default function PartnerInfo(props: IPartnerInfoProps) {
  return (
    <div
      style={{
        flex: 1,
        paddingLeft: 7,
        paddingRight: 7
      }}
    >
      {!props.loaded && !props.error &&
        ["35%", undefined, undefined, "90%", undefined, "95%"].map((width) => (
          <Shimmer
            key={crypto.randomUUID()}
            style={{ marginTop: 10 }}
            shimmerColors={{ shimmer: "rgb(222, 236, 249)" }}
            {...(width ? { width } : {})}
          />
        ))}
      {props.loaded && (
        <div>
          <h4 style={{ display: "flex", margin: 0, marginBottom: 10 }}>
            <img src={openAI} width={20} height={20} alt="OpenAI logo" />
            <span style={{ paddingLeft: 10 }}> Powered by Azure OpenAI </span>
          </h4>
          <div>{props.displaytext}</div>
        </div>
      )}
      {props.error && (
        <div>
          <h4 style={{ display: "flex", margin: 0, marginBottom: 10 }}>
            <img src={openAI} width={20} height={20} alt="OpenAI logo" />
            <span style={{ paddingLeft: 10 }}> Powered by Azure OpenAI </span>
          </h4>
          <div>{props.name}</div>
        </div>
      )}
    </div>
  );
}
